export const UNIFIED_CAMPAIGN_ROW_TEXTS = {
  READ_ONLY: "Somente leitura",
} as const;
